import { CrudModel } from "./_crud";

export class SolutionCategoryAppModel extends CrudModel {
	constructor() {
		super("app/category");
	}
}

export default new SolutionCategoryAppModel();
